module.exports = __webpack_public_path__ + "img/support.dd3f8766.png";